import ConfirmInputModalReducer from "@common/redux/reducers/ConfirmInputModalReducer";
import BaseAction from "./BaseAction";

class ConfirmInputModalAction extends BaseAction {
  onClose = () => {};

  onConfirm = () => {};

  open = async (
    message,
    title = "Error",
    onConfirm = () => {},
    onClose = () => {},
  ) => {
    this.onClose = onClose;
    this.onConfirm = onConfirm;
    this.dispatch({ open: true, message, title });
  };
}

const action = new ConfirmInputModalAction(ConfirmInputModalReducer);

export default action;
